import { RegistrationCode } from '../auth/AuthTypes'
import { RegCodeKey } from './StorageKeys'

export class VersionedRegCode {
  public readonly version: 1 | 2
  public readonly versionedValue: RegistrationCode
  public readonly value: RegistrationCode

  private static instance?: VersionedRegCode

  private constructor(regCode: RegistrationCode) {
    this.versionedValue = regCode

    switch (regCode.length) {
      case 7:
        this.version = 1
        this.value = regCode
        break
      case 8:
        this.version = 2
        this.value = regCode.slice(0, -1)
        break
      default:
        this.version = 2
        this.value = regCode
    }

    console.debug(`[VersionedRegCode] created v${this.version} code "${this.value}"`)
  }

  public static create(regCode: RegistrationCode): VersionedRegCode {
    this.instance = new VersionedRegCode(regCode)
    return this.instance
  }

  public static async save(key: RegCodeKey, code?: RegistrationCode): Promise<void> {
    if (code) {
      localStorage.setItem(key, code)
    } else if (this.instance) {
      localStorage.setItem(key, this.instance.versionedValue)
    } else {
      console.warn('[VersionedRegCode] no code to save')
    }
  }

  public static async load(key: RegCodeKey): Promise<VersionedRegCode | undefined> {
    if (this.instance) return this.instance

    const data = localStorage.getItem(key)
    return data ? this.create(data) : undefined
  }

  public static async clear(key: RegCodeKey): Promise<void> {
    localStorage.removeItem(key)
    this.instance = undefined
  }
}
